import { ICriterion } from "../../distribute-team-members/models/criterion";
import { ExecutivePlan } from "./executive-plan.model";
import { FinalReportMistakes } from "./final-report-mistakes.model";
import { Summary } from "./summary.model";

export class ExecuteVisitResult {
    criterion: ICriterion[];
    flatCriterion: ICriterion[];

    summaryOfRecommendations: Summary[];
    summaryOfCommendations: Summary[];
    summaryOfSuggestions: Summary[];
    executiveSummary: Summary[] | string;

    executivePlan: ExecutivePlan[];
    finalReportMistakes: FinalReportMistakes[];
    responseNotesDecision:boolean;
}